import "../../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useMemo } from 'react';
import MonitorWSService from '../../../services/monitorwsservice';
import { useTranslation } from 'react-i18next';
import { removeWidget } from "../../../redux/supervisorSlice";
import {
    DataGrid, Column, ColumnChooser, StateStoring, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import { Button } from 'react-bootstrap';
import CampaignDetail from "./campaigndetail";
import WidgetTools from "../widgetTools";
import { selectionTypes } from "src/components/utils/consts";
import WidgetSettings from "../widgetSettings";

function CampaignsStatus(props) {

    const dataSource = useMemo(() => {
        return new DataSource({
            store: new ArrayStore({
                key: 'id',
                data: []
            }),
            reshapeOnPush: true
        })
    }, []);

    const { t } = useTranslation();
    const [campaigns, setCampaigns] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [showCampaignDetail, setShowCampaignDetail] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/agentscards", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("agentscards");
            }
            setCampaigns([])
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {
            let campaigns = JSON.parse(localStorage.getItem(`CampaignsStatus_camps_${props.identifier}_user${props.id}`) || "[]");
            setSelectedCampaigns(campaigns);

            MonitorWSService.stompClient.send("/app/subscribe/campaignsstatustable", {}, JSON.stringify({
                token: props.token,
            }));

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/campaignsstatustable/`, function (calls) {


                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    var data = JSON.parse(calls.body);

                    let selected = JSON.parse(localStorage.getItem(`CampaignsStatus_camps_${props.identifier}_user${props.id}`) || "[]");
                    if (selected?.length > 0) {
                        data = data.filter(x => selected.indexOf(x.id) > -1);
                    }

                    let campaignsIds = dataSource.items().map(x => x.id);

                    campaignsIds.forEach(x => {
                        if (data.map(c => c.id).indexOf(x) === -1) {
                            dataSource.store().push([{ type: 'remove', key: x }]);
                        }

                    });

                    data.forEach(v => {
                        if (campaignsIds.indexOf(v.id) > -1) {
                            dataSource.store().push([{ type: 'update', key: v.id, data: v }]);
                        } else {
                            dataSource.store().push([{ type: 'insert', data: v }]);
                        }

                    });

                    setCampaigns(data.length);
                }
            }, { id: "campaignsstatustable" });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);


    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const toggleCampaignDetail = () => {
        setShowCampaignDetail(!showCampaignDetail);
    }

    const viewCampCell = (dataCell) => {
        return (
            <Button key={dataCell.value} variant="light-primary" size='sm' onClick={e => campClick(dataCell.data)}><FontAwesomeIcon icon={duotone('eye')} /></Button>
        );
    }

    const campClick = (campaign) => {
        setSelectedCampaign(campaign);
        toggleCampaignDetail();
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setCampaignsFilter = (campaigns) => {
        localStorage.setItem(`CampaignsStatus_camps_${props.identifier}_user${props.id}`, JSON.stringify(campaigns));
        setShowSettings(!showSettings);
        setSelectedCampaigns(campaigns);
        MonitorWSService.stompClient.send("/app/subscribe/campaignsstatustable", {}, JSON.stringify({
            token: props.token
        }));
    };

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("address-book")} /> {t("campaignsstatus")} <span className="badge badge-light-primary fs-base">{campaigns}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px", height: "360px" }} >

                <DataGrid
                    id="campaignsstatustable"
                    dataSource={dataSource}
                    showBorders={false}
                    highlightChanges={true}
                    repaintChangesOnly={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"99%"}
                    allowColumnResizing={true}
                    rtlEnabled={props.rtl}
                    loadPanel={{ enabled: false }

                    }
                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`campaignsStatustableTableStorage_${props.identifier}_user${props.id}`}
                    />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Paging enabled={false} />
                    <Scrolling
                        rowRenderingMode={"virtual"}
                        columnRenderingMode={"virtual"}
                    ></Scrolling>
                    <Column dataField="id" visible={false} showInColumnChooser={false} />
                    <Column caption={""} cellRender={viewCampCell} alignment="center" visible={true} width={60} />
                    <Column cssClass={"align-middle"} dataField="name" caption={t("name")} visible={true} width={120} />
                    <Column cssClass={"align-middle"} dataField="active" cellRender={e => e.value ? t("enabled") : t("disabled")} caption={t("status")} visible={true} width={110} />
                    <Column cssClass={"align-middle"} dataField="available" caption={t("available")} visible={true} width={120} />
                    <Column cssClass={"align-middle"} dataField="done" caption={t("done")} visible={true} width={120} />
                    <Column cssClass={"align-middle"} dataField="postponed" caption={t("postponed")} visible={true} width={120} />
                    <Column cssClass={"align-middle"} dataField="personalpostponed" caption={t("personalpostponed")} visible={true} width={120} />
                    <ColumnChooser enabled={true} mode={"select"} allowSearch={true} />
                </DataGrid>
            </div>
            {
                selectedCampaign &&
                <CampaignDetail show={showCampaignDetail} toggleModal={toggleCampaignDetail} campaign={selectedCampaign}></CampaignDetail>
            }
            <WidgetSettings key={`settings_${props.identifier}`} activeWidget={props.activeWidget} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setCampaignsFilter={setCampaignsFilter} selectedCampaigns={selectedCampaigns} selectionType={selectionTypes.CAMPAIGNMULTIPLE}></WidgetSettings>

        </div>
    )

}
const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { removeWidget })(CampaignsStatus);